// 活動邀請的分享文案：步道詳情的分享列與會員中心的「複製邀請碼」共用一份，
// 改文案只改這裡，兩處才不會說成兩套
const SHARE_INTRO = '邀你一起參加「115年全民親山步道票選活動」！進入活動網站完成登入後，'
const SHARE_OUTRO = '每天都能為喜歡的步道投票，還有機會抽好禮，一起來支持臺灣步道吧！⛰️'

// 登入者的版本：附上邀請碼，另外把邀請排行榜的禮券與分享加碼一起講清楚
const inviteMessage = (code) => `📣邀您參加「115年全民親山步道票選活動」
📣前500名成功邀請好友並經確認符合資格者，可獲50元數位禮券
📣分享步道訊息再加碼4張票
👉登入後至「個人資料」輸入我的邀請碼：${code}`

/**
 * 分享文字本體，不含網址：LINE 與系統分享面板會把 url 另外接在後面，寫進來就出現兩次
 * @param {string} inviteCode 登入者的邀請碼，沒有就是一般邀請
 */
export function buildShareMessage(inviteCode) {
  if (inviteCode) {
    return inviteMessage(inviteCode)
  }
  return `${SHARE_INTRO}${SHARE_OUTRO}`
}
